var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 36","width":"24","height":"24","fill":"currentColor"}},[_c('path',{attrs:{"d":_setup.MAP_POINT_PATH}})])
}
var staticRenderFns = []

export { render, staticRenderFns }